import SettingsSidebarContainer from './container'

export default SettingsSidebarContainer
